import React from "react";
import { skiCupInfo } from "../../data/Recomendations";
import MainLanding from "./MainLanding";
import LiquidContainer from "../../components/LiquidContainer";
import RecommendationSectionCard from "../../components/RecommendationCard";
import CenteredColumnLayout from "../../components/CenteredColumnLayout";
import SnowBackground from "../../components/SnowBackground";
import logo from '../../assets/images/logos/copa_logo_white.png'

const Recommendations = () => {
  return (
    <MainLanding>
        <SnowBackground />

        <CenteredColumnLayout>
            <img src={logo} style={{maxHeight: "26vh", maxWidth: "210px"}}/>
        </CenteredColumnLayout>

        <CenteredColumnLayout>
            <LiquidContainer>
                <div className='d-flex flex-column justify-content-center align-items-center m-3'>
                    {skiCupInfo.map((section) => (
                        <div key={section.id} className="m-1">
                        <RecommendationSectionCard section={section} />
                        </div>
                    ))}
                </div>
            </LiquidContainer>
        </CenteredColumnLayout>
    </MainLanding>
  );
};

export default Recommendations;
